export default "__VITE_ASSET__CabXRVPT__"